import { Token } from '../../../../../entities/applicant_tracking/jobboards/Token';
import { ApiService } from '../../../../ApiService';

export class TokenService {
  public static get(): Promise<Token> {
    return ApiService.get('/api/v1/applicant_tracking/job_boards/token');
  }
}
